import React from "react";
import imageNull from "../assets/Images/NoImage.png";
import business from "../assets/Images/imetanic-logo.png";
import userImg from "src/assets/Images/user-profile.png";

interface ImageProps {
  imagePath: string | File | null | undefined;
  className?: string;
  company?: boolean;
  profile?: boolean;
}

const Image: React.FC<ImageProps> = ({ imagePath, className = "", company = false, profile = false }) => {
  const noImage = company ? business : profile ? userImg : imageNull;

  // No image provided
  if (!imagePath) {
    return <img src={noImage} alt='No-Image' className={`object-contain ${className}`} />;
  }

  // ✅ Detect Base64 image
  const isBase64 = typeof imagePath === "string" && (imagePath.startsWith("data:image") || /^[A-Za-z0-9+/]+={0,2}$/.test(imagePath));

  // ✅ Detect S3 image
  const isS3 = typeof imagePath === "string" && imagePath.startsWith("https://s3");

  const isFile = typeof imagePath === "string" && imagePath.startsWith("blob:http");

  // ✅ Final src handling
  const src = isBase64
    ? imagePath.startsWith("data:image")
      ? imagePath
      : `data:image/png;base64,${imagePath}`
    : isS3
      ? imagePath
      : isFile
        ? imagePath
        : `${process.env.REACT_APP_IMAGE_PATH}/${imagePath}`;

  return (
    <img
      src={src}
      alt='img'
      className={`object-contain ${className}`}
      onError={(e) => {
        e.currentTarget.src = noImage;
      }}
    />
  );
};

export default Image;
